import React, { Fragment, useContext } from "react";

import { PropTypes } from "prop-types";

import { Grid } from "@mui/material";

import LoadingPage from "../../../react_utils/LoadingPage";
import SgReadyHistoryTable from "../heatpump/SgReadyHistoryTable";
import AdminLocationClient from "../../../shared/api/AdminLocationClient";
import useSgReadyHistory from "../../../shared/hooks/heatpump/useSgReadyHistory";
import { AuthContext } from "../../../shared/contexts/AuthContext";
import TablePagination from "../../../react_utils/table/TablePagination";

export default function SgReadyHistoryTab({ location }) {
  const { apiClient } = useContext(AuthContext);
  const locationClient = new AdminLocationClient(apiClient, location.id);

  const { sgReadyHistory, pagination } = useSgReadyHistory(locationClient);

  if (sgReadyHistory === null) return <LoadingPage />;

  return (
    <Fragment>
      <Grid container justify="center">
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          <SgReadyHistoryTable sgReadyHistory={sgReadyHistory} />
        </Grid>
        <Grid xs={12} sm={12} md={12} item paddingTop={"10px"}>
          <TablePagination
            nPages={pagination.nPages}
            page={pagination.page}
            setPage={pagination.setPage}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

SgReadyHistoryTab.propTypes = {
  location: PropTypes.object,
};
